import classNames from 'classnames/bind';

import styles from './S01.module.scss';

import background from '../../../assets/images/products/water/background.jpg';

const cx = classNames.bind(styles);

const S01 = () => {
  return (
    <div className={cx('container')} style={{ backgroundImage: `url(${background})` }}>
      <div className={cx(['column', 'left'])}>
        <img src={require('../../../assets/images/products/water/main-left.png')} alt="" />
      </div>
      <div className={cx(['column', 'right'])}>
        <img src={require('../../../assets/images/products/water/main-right.png')} alt="" />
      </div>
    </div>
  );
};

export default S01;
